import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlan } from 'src/features/servicePlans/utils/types';
import { ServicePlanFormSchemaValues } from 'src/features/servicePlans/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<ServicePlan> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateServicePlan };
